import { Upload } from '@aws-sdk/lib-storage'
import { S3Client } from '@aws-sdk/client-s3'
import approve from 'approvejs'
import moment from 'moment'
import { nanoid } from 'nanoid'

import { errorTitle } from './helper'

export const abbreviateNumber = (value) => {
  let newValue = value;
  if (value >= 1000) {
    const suffixes = ["", "k", "m", "b","t"];
    const suffixNum = Math.floor( (""+value).length/3 );
    let shortValue;
    for (let precision = 2; precision >= 1; precision--) {
        shortValue = parseFloat( (suffixNum !== 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
        const dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
        if (dotLessShortValue.length <= 2) { break; }
    }
    newValue = shortValue+suffixes[suffixNum];
  }
  return newValue;
}

export const currencyNumber = (value) => {
  if(value === null) return value
  else if(typeof value == 'number') return value.toLocaleString('id-ID', {style: 'currency', currency: 'IDR', minimumFractionDigits: 0})
  else return value
}

export const debounce = (func, wait, immediate) => {
  let timeout;

  return function executedFunction() {
    let context = this;
    let args = arguments;
    
    let later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    let callNow = immediate && !timeout;
	
    clearTimeout(timeout);

    timeout = setTimeout(later, wait);
	
    if (callNow) func.apply(context, args);
  };
}

export const generateMessage = (type, value, callback, timer) => {
  let result 

  result = {
    $type: type,
    message: value,
    timer: timer || (type === 'warning' ? 3000 : 2000)
  } 

  if (callback && typeof(callback) == "function") result.callback = () => {
    callback()
  }

  return result || {}
}

export const generateMessageQuestion = (type, title, subtitle, callback, buttonSubmit, cancelCallback) => {
  let result 

  result = {
    $type: type,
    title: title,
    subtitle: subtitle,
    callback: callback,
    buttonSubmit: buttonSubmit,
    cancelCallback: cancelCallback
  } 

  return result || {}
}

export const isEqual =  (value, other) => {
	const type = Object.prototype.toString.call(value);
	if (type !== Object.prototype.toString.call(other)) return false;

	if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;
	const valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
	const otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
	if (valueLen !== otherLen) return false;

	const compare = function (item1, item2) {
		const itemType = Object.prototype.toString.call(item1);
		if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
			if (!isEqual(item1, item2)) return false;
		}
		else {
			if (itemType !== Object.prototype.toString.call(item2)) return false;

			if (itemType === '[object Function]') {
				if (item1.toString() !== item2.toString()) return false;
			} else {
				if (item1 !== item2) return false;
			}

		}
	};

	if (type === '[object Array]') {
		for (let i = 0; i < valueLen; i++) {
			if (compare(value[i], other[i]) === false) return false;
		}
	} else {
		for (const key in value) {
			if (value.hasOwnProperty(key)) {
				if (compare(value[key], other[key]) === false) return false;
			}
		}
	}
	return true;
};

export const generateOptionValue = (value, label) => {
  let result 

  if(value) {
    result = {
      value : value ,
      label: (label ? label : value)
    }
  }

  return result || null
}

export const generateOptionValueArray = (value, isFixedArray) => {
  let result 

  if(Array.isArray(value)) {
    result = []
    for(let val of value) {
      result.push({
        value : val ,
        label: val,
        isFixed: (isFixedArray && isFixedArray.length) ? isFixedArray.includes(val) : false
      })
    }
  }

  return result || null
}

export const isProduction = () => {
  return window.location.hostname === "app.forstok.com" || window.location.hostname === "omni.forstok.com"
} 

export const humanise = (value) => {
  if(!value) return ''
  const underscoreMatch = /_/g,
    underscoreMatch2 = /-/g

  let  underscoresToSpaces = value.replace(underscoreMatch, " ")
    underscoresToSpaces = underscoresToSpaces.replace(underscoreMatch2, " ")

  return underscoresToSpaces
}

export const paddingNumber = (value, paddingValue, prefix) => {
  if(!value) return ''
  return (prefix || '') + String(paddingValue + value).slice(-paddingValue.length)
}

export const generateAddress = (address) => {
  if(address) {
    const firstLine = ((!address.address1 && !address.address2) ? '' : ((address.address1 ? address.address1 + ', ' : '') + (address.address2 || '') + '<br/>') ),
    secondLine = ((!address.subDistrict && !address.district && !address.city) ? '' : ((address.subDistrict ? address.subDistrict + ', ' : '') + (address.district ? address.district + ', ' : '') + (address.city || '') + '<br/>') ),
    thirdLine = ((address.postalCode ? (address.postalCode + '<br/>') : '')),
    lastLine = address.phone || ''
    return firstLine + secondLine + thirdLine + lastLine
  }
  else return '-'
}

export const evForceInput = (inputEl, value, isDisabled) => {
  if(!inputEl) return false
  const inputValue = () => setTimeout(() => { inputEl.value = value }, 1)
  inputEl.addEventListener("focusin", inputValue , false)
  inputEl.focus()
  inputEl.removeEventListener("focusin", inputValue , false)
}

export const loadImage = path => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.crossOrigin = 'Anonymous'
    img.src = path
    img.onload = () => {
      resolve(img)
    }
    img.onerror = e => {
      reject(e)
    }
  })
}

export const generateValueTable = (input, key) => {
  let result = input
  if(key && input !== '') {
    const _key = key.toLowerCase()
    if(/price/.test(_key)) {
      result = currencyNumber(input)
    }
    else if(/width/.test(_key) || /length/.test(_key) || /height/.test(_key)) {
      result = input + ' cm'
    }
    else if(/weight/.test(_key)) {
      result = input + ' gr'
    }
    else if(/discount/.test(_key)) {
      result = input + ' %'
    }
  }
  return result
}

export const generateValue = (type, value) => {
  let _value
  switch(type) {
    case 'String':
      _value = value ? value.toString().trim() : ''
      break
    case 'Integer':
      _value = (value !== '' && value !== null) ? parseInt(value) : null
      break
    case 'Currency':
      _value = (value !== '' && value !== null) ? parseInt(formatNumber(value, false)) : null
      break
    case 'Boolean':
      case 'Array':
      _value = value
      break
    default:
      _value = value.toString().trim()
  }
  return _value
}

export const generateValueList = (type, value) => {
  let _value
  switch(type.toLowerCase()) {
    case 'string':
      _value = value ? value.toString().trim() : null
      break
    case 'integer':
      _value = (value && value !== '' && value !== null) ? parseInt(value) : null
      break
    case 'currency':
      _value = (value && value !== '' && value !== null) ? currencyNumber(parseInt(value)) : null
      break
    case 'boolean':
    case 'array':
      _value = value
      break
    default:
      _value = value.toString().trim()
  }
  return _value
}

export async function fetchPost(url, body, options) {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(options?.headers ?? {}),
      },
      body: JSON.stringify(body),
      ...options,
    })

    const responseText = await response.text()
    let fetchData

    if (responseText) {
      try {
        fetchData = JSON.parse(responseText)
      } catch {
        if (response.ok) {
          throw new Error('The server returned an invalid JSON response.')
        }
      }
    }

    if (!response.ok) {
      const responseMessage = typeof fetchData?.message === 'string'
        ? fetchData.message
        : undefined

      return {
        ok: false,
        status: response.status,
        message:
          responseMessage ||
          response.statusText ||
          responseText ||
          `Request failed with status ${response.status}`,
        data: fetchData,
      }
    }

    return {
      ok: true,
      status: response.status,
      data: fetchData,
    }
  } catch (err) {
    return {
      ok: false,
      status: 0,
      message: err?.message ?? String(err),
      data: undefined,
    }
  }
}

export const generateKeyLabel = (key) => {
  const result = key.split('_').pop() || ''
  return capitalize(humanise(unCamelCase(result)), true)
}


export const validateByApproveJs = (head, value, title, valueMatch) => {
  let result = { approved: true },
      _title = title || errorTitle(head.name)

    if(head.key.indexOf('options-option') !== -1) {
      if(value === '') result = { approved: false, errors: [_title+' is required'] }
    }

    if(head?.validations) {
      const typeData = head?.typeData || 'String'
      let rules = {title: _title}

      if(head.validations?.required) {
        switch(typeData) {
          case 'String':
            rules.required = true
          break
          case 'Boolean':
            const requiredBooleanRule = {
              expects: [
                'value'
              ],
              message: '{title} is required',
              validate: (value, pars) => {
                return pars.value !== undefined && pars.value !== null
              }
            }
            approve.addTest(requiredBooleanRule, 'requiredBooleanRule')
            rules.requiredBooleanRule = {
              value: value
            }
          break
          case 'Integer': 
            case 'Currency':
            const _value = value === null ? '' : (isNaN(value) ? '' : value)
            const requiredIntegerRule = {
              expects: [
                'value'
              ],
              message: '{title} is required',
              validate: (value, pars) => {
                return pars.value !== '' && pars.value !== null
              }
            }
            approve.addTest(requiredIntegerRule, 'requiredIntegerRule')
            rules.requiredIntegerRule = {
              value: _value
            }
          break 
          case 'Array':
            const requiredArrayRule = {
              expects: [
                'value'
              ],
              message: '{title} is required',
              validate: (value, pars) => {
                return ((pars.value && pars.value.length) || (pars.value && Object.keys(pars.value).length)) ? true : false 
              }
            }
            approve.addTest(requiredArrayRule, 'requiredArrayRule')
            rules.requiredArrayRule = {
              value: value
            }
          break
          default: 
            rules.required = true
        }
      }

      if(head.validations?.requiredIf) {
        const requiredIfRule = {
          expects: [
            'value',
            'valueMatch',
          ],
          message: '{title} is required',
          validate: (value, pars) => {
            if (pars?.valueMatch) {
              if (IsNumeric(pars?.valueMatch)) {
                return (pars?.valueMatch > 0 && value) ? true : false
              } else {
                return (pars?.valueMatch && value) ? true : false
              }
            } else return true
          }
        }
        approve.addTest(requiredIfRule, 'requiredIfRule')
        rules.requiredIfRule = {
          value: value,
          valueMatch: valueMatch
        }
      }

      if(('min' in head.validations && head.validations.min !== null) && ('max' in head.validations && head.validations.max !== null)) {
        switch(typeData) {
          case 'Integer':
            case 'Currency':
            const minMaxMin = head.validations.min
            const minMaxMax = head.validations.max
            const minMaxIntegerRule = {
              expects: [
                'value'
              ],
              message: '{title} min '+minMaxMin+' and max '+minMaxMax,
              validate: (value, pars) => {
                return (pars.value >= minMaxMin && pars.value <= minMaxMax) || pars.value === '' || pars.value === null
              }
            }
            const minMaxIntegerRuleName = 'minMaxIntegerRule_' + head.key
            approve.addTest(minMaxIntegerRule, minMaxIntegerRuleName)
            rules[minMaxIntegerRuleName] = {
              value: value
            }
          break
          case 'Array':
            const minMaxArrayMin = head.validations.min
            const minMaxArrayMax = head.validations.max
            const minMaxArrayRule = {
              expects: [
                'value'
              ],
              message: '{title} must be a minimum of '+minMaxArrayMin+' and a maximum of '+minMaxArrayMax,
              validate: (value, pars) => {
                return pars.value ? (pars.value.length >= minMaxArrayMin &&  pars.value.length <= minMaxArrayMax) : (minMaxArrayMin === 0 ? true : false)
              }
            }
            const minMaxArrayRuleName = 'minMaxArrayRule_' + head.key
            approve.addTest(minMaxArrayRule, minMaxArrayRuleName)
            rules[minMaxArrayRuleName] = {
              value: value
            }
          break
          default: 
            rules.min = head.validations.min
            rules.max = head.validations.max
        }
      }
      else if('min' in head.validations && head.validations.min !== null) {
        switch(typeData) {
          case 'Integer':
            case 'Currency':
            const minValue = head.validations.min
            const minIntegerRule = {
              expects: [
                'value'
              ],
              message: '{title} min '+minValue,
              validate: (value, pars) => {
                return pars.value >= minValue || pars.value === '' || pars.value === null
              }
            }
            const minIntegerRuleName = 'minIntegerRule_' + head.key
            approve.addTest(minIntegerRule, minIntegerRuleName)
            rules[minIntegerRuleName] = {
              value: value
            }
          break
          case 'Array':
            const minArrayMin = head.validations.min
            const minArrayRule = {
              expects: [
                'value'
              ],
              message: '{title} must be a minimum of '+minArrayMin,
              validate: (value, pars) => {
                return pars.value ? (pars.value.length >= minArrayMin) : (minArrayMin === 0 ? true : false)
              }
            }
            const minArrayRuleName = 'minArrayRule_' + head.key
            approve.addTest(minArrayRule, minArrayRuleName)
            rules[minArrayRuleName] = {
              value: value
            }
          break
          default: 
            rules.min = head.validations.min
        }
      }
      else if('max' in head.validations && head.validations.max !== null) {
        switch(typeData) {
          case 'Integer':
            case 'Currency':
            const maxValue = head.validations.max
            const maxIntegerRule = {
              expects: [
                'value'
              ],
              message: '{title} max '+maxValue,
              validate: (value, pars) => {
                return pars.value <= maxValue || pars.value === '' || pars.value === null
              }
            }
            const maxIntegerRuleName = 'maxIntegerRule_' + head.key
            approve.addTest(maxIntegerRule, maxIntegerRuleName)
            rules[maxIntegerRuleName] = {
              value: value
            }
          break
          case 'Array':
            const maxArrayMax = head.validations.max
            const maxArrayRule = {
              expects: [
                'value'
              ],
              message: '{title} must be a maximum of '+maxArrayMax,
              validate: (value, pars) => {
                return pars.value ? (pars.value.length <= maxArrayMax) : true
              }
            }
            const maxArrayRuleName = 'maxArrayRule_' + head.key
            approve.addTest(maxArrayRule, maxArrayRuleName)
            rules[maxArrayRuleName] = {
              value: value
            }
          break
          default: 
            rules.max = head.validations.max
        }
      }
      if('lessEqual' in head.validations) {
        const lessEqualRule = {
          expects: [
            'value',
            'valueMatch',
          ],
          message: `${generateKeyLabel(head.key)} must be lower than or equal to ${generateKeyLabel(head.validations.lessEqual)}`,
          validate: (value, pars) => {
            return (IsNumeric(value) && IsNumeric(pars?.valueMatch)) ? (value <= pars.valueMatch) : true
          }
        }
        approve.addTest(lessEqualRule, 'lessEqualRule')
        rules.lessEqualRule = {
          value: value,
          valueMatch: valueMatch
        }
      }
      if('less' in head.validations) {
        const lessRule = {
          expects: [
            'value',
            'valueMatch',
          ],
          message: `${generateKeyLabel(head.key)} must be lower than ${generateKeyLabel(head.validations.less)}`,
          validate: (value, pars) => {
            return (IsNumeric(value) && IsNumeric(pars?.valueMatch)) ? (value < pars.valueMatch) : true
          }
        }
        approve.addTest(lessRule, 'lessRule')
        rules.lessRule = {
          value: value,
          valueMatch: valueMatch 
        }
      }
      if(head.validations?.greaterEqual) {
        const greaterEqualRule = {
          expects: [
            'value',
            'valueMatch',
          ],
          message: `${generateKeyLabel(head.key)} must be higher than or equal to ${generateKeyLabel(head.validations.greaterEqual)}`,
          validate: (value, pars) => {
            return (IsNumeric(value) && IsNumeric(pars?.valueMatch)) ? (value >= pars.valueMatch) : true
          }
        }
        approve.addTest(greaterEqualRule, 'greaterEqualRule')
        rules.greaterEqualRule = {
          value: value,
          valueMatch: valueMatch
        }
      }
      if(head.validations?.greater) {
        const greaterRule = {
          expects: [
            'value',
            'valueMatch',
          ],
          message: `${generateKeyLabel(head.key)} must be higher than ${generateKeyLabel(head.validations.greater)}`,
          validate: (value, pars) => {
            return (IsNumeric(value) && IsNumeric(pars?.valueMatch)) ? (value > pars.valueMatch) : true
          }
        }
        approve.addTest(greaterRule, 'greaterRule')
        rules.greaterRule = {
          value: value,
          valueMatch: valueMatch
        }
      }
      result = approve.value(value, rules)
    }
    return result
} 

export const unescapeHTML = (value) => {
  return value.replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&');
}

export const getStorage = (name, defaultVal, jsons = true, loadName= 'load') => {
  const defaultValue = defaultVal
  let result = defaultValue
  if(sessionStorage.getItem(loadName)) {
    result = sessionStorage.getItem(name) || defaultValue
  }else {
    result = localStorage.getItem(name) || defaultValue
    sessionStorage.setItem(name, result)
  }
  jsons = (result === 'all' || result === undefined || result === 'undefined' || (Array.isArray(result) && !result.length) ) ? false : jsons
  const reResult = (result  === undefined || result === 'undefined') ? {} : result
  return jsons ? JSON.parse(reResult) : reResult
}

export const setStorage = (name, value, only) => {
  switch(only) {
    case 'session':
      sessionStorage.setItem(name, value)
      break
    case 'local':
      localStorage.setItem(name, value)
      break
    default:
      sessionStorage.setItem(name, value)
      localStorage.setItem(name, value)
  }
  return true
}

export const unCamelCase = (value) => {
  return value.replace(/([a-z][A-Z])/g, function (g) { return g[0] + '_' + g[1].toLowerCase() })
}

export const unCamelCaseKeys = (object) => {  
  return Object
    .entries(object)
    .reduce((carry, [key, value]) => {
      carry[unCamelCase(key)] = value
      return carry
    }, {})
}

export const generateOriginKey = (key, arrString) => {
  let result = key
  for(let arr of arrString) result = result.replace(arr, '')
  return result
}

export const generateDefaultValue = (field) => {
  let _value = ''
  switch(field.fieldType) {
    case 'select':
    case 'select_async_pagination':
      _value = null
      if (field.key === 'variants-tax' && !_value) {
        const taxEl = document.querySelector('#tax')
        if (taxEl && field.options?.length) {
          _value = taxEl.innerHTML === 'true'
        }
      }
      break
    case 'image':
      _value = (field.typeData === 'Array') ? null : ''
      break
    case 'tag':
      _value = (field.typeData === 'Array') ? null : ''
      break
    case 'date':
      _value = field.validations?.required ? moment(new Date()).format("DD/MM/YYYY") : ''
      break  
    case 'input':
      _value = (field.typeData === 'Integer') ? null : ''
      break   
    case 'checkbox': 
      _value = (field.typeData === 'Boolean') ? false : ''
      break   
    default:
      _value = ''
  }
  return _value
}

export const capitalize = (value, each) => {
  let result = value
  if (value) {
    if (each) {
      var splitStr = value.toLowerCase().split(' ')
      for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)  
      }
      result = splitStr.join(' ')
    } else {
      result = value[0].toUpperCase() + value.substring(1)
    }
  }
  return result
}

export const pasteIntoInput = (el, text) => {
  el.focus()
  if (typeof el.selectionStart == "number" && typeof el.selectionEnd == "number") {
    var val = el.value
    var selStart = el.selectionStart
    el.value = val.slice(0, selStart) + text + val.slice(el.selectionEnd)
    el.selectionEnd = el.selectionStart = selStart + text.length
  } else if (typeof document.selection != "undefined") {
    var textRange = document.selection.createRange()
    textRange.text = text
    textRange.collapse(false)
    textRange.select()
  }
}

export const slugify = (string) => {
  if(!string) return ''

  return string
    .toString()
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "")
}

export const generateAutoCopyKey = (keyAlias, variantIdx, optionIdx, header) => {
  let result = keyAlias
  if(header?.condition === 'variant') result += '-variant-'+variantIdx
  if(keyAlias === 'options-type' || keyAlias === 'options-option') result += '-'+optionIdx
  return result
}

export const isErrorEscape = (error) => {
  return error && error?.networkError?.name !== 'AbortError'
}

export const getSizeContainer = () => {
  const height = window.innerHeight
  const width = window.innerWidth
  let result = { width: width, height: height }  
  if (width >= 1366) {
    result.width = width - 220 - 64
  } else if (width >= 1280) {
    result.width = width - 187 - 32
  }
  return result
}

export const getStyleWidthbyMediaQuery = () => {
  const width = document.body.clientWidth

  let result = 1024
  if(width >= 1680) {
    result = 1680
  } else if(width >= 1440) {
    result = 1440
  } else if(width >= 1280) {
    result = 1280
  } else if(width >= 1024) {
    result = 1024
  }

  return result
}

export const generateSUM = (names, data) => {
  let result = 0
  if(data && names) {
    result = data.reduce((_sum, cur) => {
      let _name
      if (Array.isArray(names)) {
        _name = cur
        for (const name of names) {
          if (name in _name) {
            _name = _name[name]
          }
        }
      } else {
        _name = cur[names]
      }
      return _sum + _name
    } ,0)
  }
  return result
}

export const getURLExtension = (url) => {
  return url.split(/[#?]/)[0].split('.').pop().trim()
}

export const evCompareCacheListing = (existing, incoming, args, readField) => {
  let result = true
  // console.log(args, "args", existing, incoming)
  if (incoming?.edges && existing?.edges) {
    const incomingNodeMap = new Map(
      incoming.edges.map((listingInc) => {
        const _listingInc = readField("node", listingInc)
        const _idInc = readField("id", _listingInc)
        const _variantsInc = readField("variants", _listingInc) || []
        const variantIds = _variantsInc.map((variant) => readField("id", variant))

        return [_idInc, variantIds]
      })
    )
    if (incomingNodeMap.size !== incoming.edges.length) {
      return false
    }
    let BreakException = {}
    try {
      console.group("cache", args)
      existing.edges.forEach((listing) => {
        const _listing = readField("node", listing)
        const _id = readField("id", _listing)
        const _variants = readField("variants", _listing) || []
        const incomingVariantIds = incomingNodeMap.get(_id)

        console.log(_id, "(existing)", "in", incomingNodeMap.has(_id), "(incoming)", "listing.id")
        if (!incomingVariantIds) return

        const incomingVariantIdSet = new Set(incomingVariantIds)
        if (incomingVariantIdSet.size !== incomingVariantIds.length) throw BreakException

        _variants.forEach((variant) => {
          const _variantId = readField("id", variant)
          console.log(_variantId, "(existing)", "in", incomingVariantIdSet.has(_variantId), "(incoming)", "listing.variant.id")
          if (!incomingVariantIdSet.has(_variantId)) throw BreakException
        })
      })
      console.groupEnd()
    } catch (e) {
      if (e !== BreakException) {
        throw e
      } else {
        console.warn("different ->", existing, incoming, args)
        result = false
      }
    }
  }

  return result
}

export const evUpdateInputRc = (input, value) => {
  if (!input) return false
  const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
    window.HTMLInputElement.prototype,
    "value"
  ).set
  nativeInputValueSetter.call(input, (value === undefined ? '' : value))
  const inputEvent = new Event('input', { bubbles: true})
  input.dispatchEvent(inputEvent)
}

export const evGenerateValueMatch = (validation, data) => {
  let result = undefined
  if (validation && Object.keys(validation).length) {
    const keyArr = ['lessEqual', 'greaterEqual', 'less', 'greater', 'requiredIf']
    const key = keyArr.find((_key) => _key in validation)
    if (data && key) {
      const obj = validation[key]
      if(obj && obj in data) result = data[obj]
    }
  }
  return result
}

export const evScrollTo = (el, range) => {
  const _range = range || 140
  if (el) {
    setTimeout(() => {
      const viewportEl = document.querySelector('._refMasterTableViewport')
      if (!viewportEl) return
      
      const bodyRect = viewportEl.getBoundingClientRect(),
            elemRect = el.getBoundingClientRect()
      if(elemRect) {
        const offsetTop = (elemRect.top - bodyRect.top - _range) + viewportEl.scrollTop,
              offsetLeft = (elemRect.left - bodyRect.left) + viewportEl.scrollLeft
        viewportEl.scrollTo(offsetLeft,offsetTop)
      }      
    }, 20)
  }
}

export const evSortbySku = (results) => {
  return results.sort((a, b) => {
    const aValue = a?.product?.sku || ''
    const bValue = b?.product?.sku || ''
    if (aValue < bValue) return 1
    if (aValue > bValue) return -1
    return 0
  })
}

export const evLoadingMasterTable = (flag) => {
  const loadingWrapperEl = document.querySelector('.loadingWrapper')
  if (!loadingWrapperEl) return false
  return flag ? loadingWrapperEl.classList.remove('hidden') : loadingWrapperEl.classList.add('hidden')
} 

export const evRenameImage = (name) => {
  const ext = (/[.]/.exec(name)) ? /[^.]+$/.exec(name) : undefined
  let result = name.replace(/\.[^/.]+$/, "")
  result = result.replace(/[&\\/\\#, +()$~%.'":@^*?<>{}]/g, '')
  if (ext) result += '.'+ext
  return result
}

export const formatNumber = (n, flag) => {
  const _flag = flag === undefined ? true : flag
  let result = ''
  if (n !== '' && n !== null && n !== undefined) {
    result = n?.toString().replaceAll(".", "")
    if (result.length === 2 && result.substring(0, 1) === "0") result = parseInt(result).toString()
    if (_flag) result = result.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  }
  return result
}

export const IsNumeric = (val) => {
  return Number(parseFloat(val)) === val
}

export const evHighlight = (ids) => {
  if (!ids?.length) return
  const timer = Math.ceil(ids.length/10)*10 <= 10 ? 30 : (Math.ceil(ids.length/10)*10 >= 200 ? 200 : Math.ceil(ids.length/10)*10) 
  setTimeout(() => {
    const contentHightlightedEls = document.querySelectorAll('._refMasterTableBodyContent.is-highlighted')
    if (contentHightlightedEls?.length) {
      for(const contentHightlightedEl of contentHightlightedEls) {
        contentHightlightedEl.classList.remove('is-highlighted')
      }
    }
    for(let i = 0; i < ids.length; i++) {
      const id = ids[i]
      const el = document.querySelector(`#row-${id}`)
      if (el) {
        el.classList.add('is-highlighted')
        setTimeout(() => {
          el.classList.remove('is-highlighted')
        }, 1888)
      }
      if(i === (ids.length - 1)) {
        const firstEl = document.querySelector(`#row-${ids[0]}`)
        firstEl && evScrollTo(firstEl, 140)
      }
    }
  }, timer)
}

export const evGenerateDataPriceTable = (data, response) => {
  let newData = [...data]
  let ids = []
  if (response.GetVariantProducts?.length) {
    response.GetVariantProducts.forEach((variant, idx) => {
      const productIdx = newData.findIndex(_product => _product.id === variant.id)
      if (productIdx < 0) {
        let product = {
          id: variant.id,
          item: {
              imageUrl: variant.imageUrl,
              name: variant.variantName,
              sku: variant.sku,
              barcode: variant.barcode
          },
          options: variant.options ? (variant.options.reduce((str, option, index) => str + `${index? ', ' : ''}${option.option || '-'}`, '')) : '-',
          price: variant.regularPrice,
          price_base: variant.regularPrice,
          salePrice: variant.salePrice,
          salePrice_base: variant.salePrice
        }
        if (variant.listings?.length) {
          variant.listings.forEach(listing => {
            product[`${listing.accountId}_listingId`] = listing.listingId
            product[`${listing.accountId}_price`] = listing.price
            product[`${listing.accountId}_price_base`] = listing.price
            if (listing.salePrice !== null) {
              product[`${listing.accountId}_salePrice`] = listing.salePrice.salePrice
              product[`${listing.accountId}_salePrice_base`] = listing.salePrice.salePrice
              product[`${listing.accountId}_saleStartAt`] = listing.salePrice.startAt
              product[`${listing.accountId}_saleStartAt_base`] = listing.salePrice.startAt
              product[`${listing.accountId}_saleEndAt`] = listing.salePrice.endAt
              product[`${listing.accountId}_saleEndAt_base`] = listing.salePrice.endAt
            }
          })
        }
        newData.push(product)
      }
    })
    ids = response.GetVariantProducts.map(variant => variant.id)
  }
  return {
    data: newData,
    ids: ids
  }
}

export const evGenerateDataStockTable = (data, response, type, isScan) => {
  let newData = [...data]
  let ids = []
  if (response.GetVariantProducts?.length) {
    response.GetVariantProducts.forEach((variant, idx) => {
      const productIdx = newData.findIndex(_product => _product.id === variant.id)
      if (productIdx < 0) {
        let product = {
          id: variant.id,
          item: {
              imageUrl: variant.imageUrl,
              name: variant.productName,
              sku: variant.sku,
              barcode: variant.barcode
          },
          options: variant.options ? (variant.options.reduce((str, option, index) => str + `${index? ', ' : ''}${option.option || '-'}`, '')) : '-'
        }
        if (type === 'adjustment' || type === 'inbound' || type === 'outbound' || type === 'transfer') {
          product.qtyOnHand = variant.warehouse?.[0]?.quantityOnHand
          product.qtyReserved = variant.warehouse?.[0]?.reservedQuantity
        }
        if(type === 'adjustment') {
          product.quantity = null
          product.qtyAdjusted = ''
        } else if(type === 'inbound') {
          product.quantity = 1
        } else if(type === 'outbound') {
          product.quantity = 0
        } else if(type === 'transfer') {
          product.quantity = null
        }
        newData.push(product)
      } else if (isScan) {
        const productExt = {...newData[productIdx]}
        if(type !== 'adjustment') {
          const qty = productExt.quantity + 1
          productExt.quantity = qty
        }
        newData.splice(productIdx, 1, productExt)
      }
    })
    ids = response.GetVariantProducts.map(variant => variant.id)
  }
  return {
    data: newData,
    ids: ids
  }
}

export const evKeyMapperScanner = (oEvent) => {
  var iCode = oEvent.which
  switch (true) {
    case iCode >= 48 && iCode <= 90:
    case (iCode >= 106 && iCode <= 111) || iCode === 45 || iCode === 173 || iCode === 189:
      if (oEvent.key !== undefined && oEvent.key !== '') {
        return oEvent.key
      }
      var sDecoded = String.fromCharCode(iCode)
      switch (oEvent.shiftKey) {
        case false: 
          sDecoded = sDecoded.toLowerCase()
          break
        case true: 
          sDecoded = sDecoded.toUpperCase()
          break
        default:
          break
      }
      return sDecoded
    case iCode >= 96 && iCode <= 105:
      return 0+(iCode-96)
    default:
      break
  }
  return ''
}

export const evCloseDropdown = e => {
  const containerEl = e.target.closest('._refContainer'),
  isOpen = containerEl.classList.contains('is-shown')
  if(isOpen) {
    const ContainerRef = document.getElementsByClassName('_refContainer is-shown')
    if(ContainerRef.length) {
      for(var i = 0; i < ContainerRef.length; i++){
        const overlay = ContainerRef[i].querySelector(`._refDropdownOverlay`)
        overlay.style.display = 'none'
        ContainerRef[i].classList.remove('is-shown')
      }
    }  
    const bodyEl = document.getElementsByTagName("BODY")[0],
          refScrollContainerEl = document.querySelector('._refScrollContainer')
    bodyEl.classList.remove("is-immuned")
    if (refScrollContainerEl) {
      refScrollContainerEl.style.overflow = "auto"
      refScrollContainerEl.firstChild.style.overflowY = null
    }
  }
}

export const uploadFile = async (config, file, callbackUpload, failedCallbackUpload, rename=true) => {
  const fileName = rename ? evRenameImage(file.name) : file.name
  const upload = new Upload({
    client: new S3Client({
      credentials: {
        accessKeyId: config.accessKeyId,
        secretAccessKey: config.secretAccessKey,
      },
      region: config.region
    }),
    params: {
      ACL:'public-read',
      Bucket: config.bucketName,
      Key: config.dirName + '/' + fileName,
      Body: file,
      ContentType: file.type
    },
  })
  try {
    const data = await upload.done()
    const location = data.Location
    if (callbackUpload && typeof(callbackUpload) == "function") callbackUpload(location) 
  } catch (err) {
    if (failedCallbackUpload && typeof(failedCallbackUpload) == "function") failedCallbackUpload() 
    return `Error!: ${err}`
  }
}

export const uploadFileMinio = async (type, file, callbackUpload, failedCallbackUpload, rename=true) => {
  const fileName = rename ? evRenameImage(file.name) : file.name
  const upload = new Upload({
    client: new S3Client({
      endpoint: 'https://gpc-assets.forstok.com',
      credentials: {
        accessKeyId: process.env.REACT_APP_MINIO_ACCESSID,
        secretAccessKey: process.env.REACT_APP_MINIO_ACCESSKEY,
      },
      region: 'ap-southeast-1', // Required by SDK, MinIO doesn't use this string
      forcePathStyle: true // Required for MinIO
    }),
    params: {
      ACL:'public-read',
      Bucket: type === 'images' ? 'public' : type,
      Key: type === 'images' ? `images/${nanoid()}/` + fileName : `${nanoid()}/` + fileName,
      Body: file,
      ContentType: file.type
    },
  })
  try {
    const data = await upload.done()
    const location = data.Location
    if (callbackUpload && typeof(callbackUpload) == "function") {
      callbackUpload(location) 
    }
  } catch (err) {
    if (failedCallbackUpload && typeof(failedCallbackUpload) == "function") {
      failedCallbackUpload() 
    }
    return `Error!: ${err}`
  }
}

export const evExecuteError = (evCreateMessage) => {
  const msg = generateMessage('failed', 'Validation Errors found, Please fix it!');
  evCreateMessage && evCreateMessage(msg);
  const errorEl = document.querySelectorAll('.cell-error')
  if (errorEl.length) {
    evScrollTo(errorEl[0])
  }
}

export const evCheckAllValidation = (data) => {
  let isError = false
  for (let x=0; x<data.length; x++) {
    const _data = data[x]
    const keys = Object.keys(_data)

    for (const key of keys) {
      if (Array.isArray(_data[key])) {
        for (let i = 0; i < _data[key].length; i++) {
          const _dataArr = _data[key][i]
          const keysArr = Object.keys(_dataArr)
          for (const keyArr of keysArr) {
            if (Array.isArray(_dataArr[keyArr])) {
              for (let z = 0; z < _dataArr[keyArr].length; z++) {
                const _dataArrArr = _dataArr[keyArr][z]
                const keysArrArr = Object.keys(_dataArrArr)
                for (const keyArrArr of keysArrArr) {
                  if (keyArrArr.indexOf('_error') !== -1 && !isError) {
                    isError = true
                  }
                  if (isError) {
                    break
                  }
                }
                if (isError) {
                  break
                }
              }
            } else {
              if (keyArr.indexOf('_error') !== -1 && !isError) {
                isError = true
              }
              if (isError) {
                break
              }
            }
            if (isError) {
              break
            }
          }
          if (isError) {
            break
          }
        }
      } else {
        if (key.indexOf('_error') !== -1 && !isError) {
          isError = true
        }
        if (isError) {
          break
        }
      }
      if (isError) {
        break
      }
    }
  }
  return isError
}

export const evCheckAllValidationByHeader = (data, headerColumns) => {
  let isError = false 
  const validByHeader = (key, valuex, idx, title = null) => {
    const __idx = idx || 0
    const validHeaderKeyFilter = headerColumns.filter(header => (header.key === key && header.validations))
    if (validHeaderKeyFilter.length) {
      const head = validHeaderKeyFilter[__idx]
      const type = head.typeData || 'String'
      const _value = generateValue(type, valuex)
      const valid = validateByApproveJs(head, _value, title || '')
      return valid      
    }
    return { approved: true } 
  }

  const newData = []
  for (let x=0; x<data.length; x++) {
    const _data = data[x]
    const keys = Object.keys(_data)

    for (const key of keys) {
      let _valid = { approved: true }
      if (Array.isArray(_data[key])) {
        for (let i = 0; i < _data[key].length; i++) {
          const _dataArr = _data[key][i]
          const keysArr = Object.keys(_dataArr)
          for (const keyArr of keysArr) {
            if (Array.isArray(_dataArr[keyArr])) {
              for (let z = 0; z < _dataArr[keyArr].length; z++) {
                const _dataArrArr = _dataArr[keyArr][z]
                const keysArrArr = Object.keys(_dataArrArr)
                for (const keyArrArr of keysArrArr) {
                  _valid = validByHeader(keyArrArr, _dataArrArr[keyArrArr])
                  if (!_valid.approved) {
                    _dataArrArr[`${keyArr}_error`] = _valid.errors[0]
                    if (!isError) {
                      isError = true
                    }
                  }
                  if (keyArrArr.indexOf('_error') !== -1 && !isError) {
                    isError = true
                  }
                }
              }
            } else {
              _valid = validByHeader(keyArr, _dataArr[keyArr])
              if (!_valid.approved) {
                _dataArr[`${keyArr}_error`] = _valid.errors[0]
                if (!isError) {
                  isError = true
                }
              }
              if (keyArr.indexOf('_error') !== -1 && !isError) {
                isError = true
              }
            }
          }
        }
      } else {
        _valid = validByHeader(key, _data[key])
        if (!_valid.approved) {
          _data[`${key}_error`] = _valid.errors[0]
          if (!isError) {
            isError = true
          }
        }
        if (key.indexOf('_error') !== -1 && !isError) {
          isError = true
        }
      }
    }
    newData.push(_data)
  }
  return { error: isError, data: newData }
}

export const evCheckAllValidationByHeaderWithVariant = (newData, headerColumns) => {
  let isError = false 
  const validByHeader = (key, valuex, idx, content) => {
    const _idx = idx || 0,
          validHeaderKeyFilter = headerColumns.filter(header => (header.key === key && header.validations))
    if(validHeaderKeyFilter.length) {
      const head = validHeaderKeyFilter[_idx],
            type = head.typeData || 'String',
            _value = generateValue(type, valuex),
            valid = validateByApproveJs(head, _value, undefined, evGenerateValueMatch(head.validations, content))
      return valid      
    }
    return {approved: true} 
  }

  let _newData = [...newData]
  for(let x=0; x<_newData.length; x++) {
    let _data = _newData[x],
        keys = Object.keys(_data)

    for(let key of keys) {
      if(Array.isArray(_data[key]) && _data[key].length && typeof _data[key][0] === 'object') {
        for(let i = 0; i < _data[key].length; i++){
          const _dataArr = _data[key][i],
                keysArr = Object.keys(_dataArr)
          for(let keyArr of keysArr) {
            if(!Array.isArray(_dataArr[keyArr])) {
              const _key = `${key}-${keyArr}`,
              valid = validByHeader(_key, _dataArr[keyArr], undefined, _dataArr)
              if(!valid.approved) {
                _dataArr[`${keyArr}_error`] = valid.errors[0]
                if(!isError) isError = true
              }
            }
          }
        }
      }else {
        const valid = validByHeader(key, _data[key], undefined, _data)
        if(!valid.approved) {
          _data[`${key}_error`] = valid.errors[0]
          if(!isError) isError = true
        }
      }
    }      
    _newData.splice(x, 1, _data)
  }
  return { error: isError, data: _newData }
}

export const isDesktop = () => {
  return document.body.clientWidth >= 1024 ? true : false;
}

export const isTablet = () => {
  return (document.body.clientWidth >= 768 && document.body.clientWidth < 1024) ? true : false;
}

export const isMobile = () => {
  return document.body.clientWidth < 768 ? true : false;
}

export function capitalizeWords(
  text,
  ignoreWords = [],
) {
  const ignoreSet = new Set<string>(ignoreWords);

  return text.replace(/\S+/g, (word, offset) => {
    const lower = word.toLowerCase();

    if (ignoreSet.has(lower) && offset !== 0) {
      return lower;
    }

    return lower.charAt(0).toUpperCase() + lower.slice(1);
  });
}